import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const {
  profile: {
    bandDetails: { bandInfoFormFields },
  },
} = copy;

export const fields: IFormFields = [
  {
    name: "nickname",
    label: bandInfoFormFields.nickname,
    type: IFieldType.text,
  },
  {
    name: "function",
    label: bandInfoFormFields.function,
    type: IFieldType.text,
  },
];

export const defaultValues = {};
